import React from 'react';
import LegalLayout from '../legal/LegalLayout';
import { ImpressumBuildingIllustration } from '../legal/illustrations';

/**
 * Impressum (§ 5 DDG / TMG) for the MainEvents platform, operated by Seuytel.
 * Items in [eckigen Klammern] still need real values before going live
 * (legal form, managing director, register entry, VAT-ID, supervisory data).
 */
export default function Impressum() {
  return (
    <LegalLayout
      eyebrow="Anbieterkennzeichnung"
      title="Impressum"
      intro="Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG) zum Betreiber der MainEvents-Plattform."
      art={<ImpressumBuildingIllustration />}
    >
      <h2>Diensteanbieter</h2>
      <div className="se-card">
        Seuytel UG (haftungsbeschränkt)
        <br />
        Walkürenring 4<br />
        38106 Braunschweig<br />
        Deutschland
      </div>

      <h2>Vertreten durch</h2>
      <p>
        <span className="se-placeholder">Rayan Dofang Seuyep / Geschäftführer</span>
        <br />
        <span className="se-placeholder">Harold Tela Mangoua</span>
      </p>

      <h2>Kontakt</h2>
      <p>
        E-Mail:{' '}
        <a href="mailto:support@mainevents.seuytel.com">support@mainevents.seuytel.com</a> 
      </p>

      <h2>Registereintrag</h2>
      <p>
        <span className="se-placeholder">
          Amtsgericht Braunschweig, HRB 212481
        </span>
      </p>

      <h2>Umsatzsteuer-ID</h2>
      <p>
        Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:{' '}
        <span className="se-placeholder">DE456107179</span>
      </p>

      <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
      <p>
        <span className="se-placeholder">Rayan Dofang Seuyep / Geschäftführer</span>
        <br />
        <span className="se-placeholder">Harold Tela Mangoua</span>
        <br />
        Walkürenring 4, 38106 Braunschweig
      </p>

      <h2>EU-Streitschlichtung</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur
        Online-Streitbeilegung (OS) bereit:{' '}
        <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer">
          https://ec.europa.eu/consumers/odr/
        </a>
        . Unsere E-Mail-Adresse finden Sie oben in diesem Impressum.
      </p>

      <h2>Verbraucherstreitbeilegung</h2>
      <p>
        Wir sind nicht verpflichtet und grundsätzlich nicht bereit, an
        Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
        teilzunehmen.
      </p>

      <h2>Haftung für Inhalte und Links</h2>
      <p>
        Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf
        diesen Seiten verantwortlich. Für Inhalte externer Links sind
        ausschließlich deren Betreiber verantwortlich; zum Zeitpunkt der
        Verlinkung waren keine Rechtsverstöße erkennbar.
      </p>
    </LegalLayout>
  );
}
